export const environment = {
  name: "qa",
  production: true,
  "signalrServer": {
    "url": "https://cloudradialchat-signalr-qa-east01.azurewebsites.net/api"
  },
  chatboxenv: "qa",
  stripe: {
    key: "pk_live_51ItJYGAjP2XCQIBGk8JOyE3gGs6J5UQ8CXC8LynyGcBeOJ0pOoY5R2TPaT2Kk4jYVqgGyKjhARVUnQZX5eumBJtE00jJ2IU6Bx"
  },
  // Empty = LogRocket disabled. Only environment.prod.ts carries the app ID (CHAT-166).
  logRocketAppId: ""
};

